import React from 'react';
import colors from '../styles/colors';

function AboutTab() {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
      <h2 className="text-2xl font-bold mb-4 text-indigo-950">About Museome</h2>

      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-3 text-indigo-950 border-b-2 border-gold pb-2 inline-block">Mission</h3>
        <p className="mb-4">
          Turn your home into your personal art gallery of personal masterpieces displaying your loved ones or special memories.
        </p>
        <p>
          We will turn your photos into your personal masterpiece.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold mb-3 text-indigo-950 border-b-2 border-gold pb-2 inline-block">Our Team</h3>
        <p className="mb-4">
         We love art and we love technology, we treat technology like an art and we ground it with real art and artistry.
        </p>

      </section>
    </div>
  );
}

export default AboutTab;
